export enum MessageType {
  Notice = 'notice',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
}
